import { useResetAtom } from 'jotai/utils'
import { useUnmount } from 'react-use'

import { highlightedCellAtom } from '~/atoms/highlightedCellAtom'

import {
  brandIdsAtom,
  columnCustomerAttributeIdsAtom,
  columnsDiffsAtom,
  commentBySegmentDisplayTypeAtom,
  customerAttributeIdsAtom,
  dataDisplayTypeAtom,
  hiddenRowIdsAtom,
  isPendingTabulationAtom,
  isTabulationReadyAtom,
  questionIdsAtom,
  savedCommentBySegmentDisplayTypeAtom,
  segmentDisplayTypeAtom,
  sortValueAtom,
  tabulationDataAtom,
} from '../atoms'

export const useResetOnUnmount = () => {
  const resetColumnCustomerAttributeIds = useResetAtom(
    columnCustomerAttributeIdsAtom,
  )
  const resetBrandIds = useResetAtom(brandIdsAtom)
  const resetQuestionIds = useResetAtom(questionIdsAtom)
  const resetCustomerAttributeIds = useResetAtom(customerAttributeIdsAtom)
  const resetDataDisplayType = useResetAtom(dataDisplayTypeAtom)
  const resetSegmentDisplayType = useResetAtom(segmentDisplayTypeAtom)
  const resetSortValue = useResetAtom(sortValueAtom)
  const resetHiddenRowIds = useResetAtom(hiddenRowIdsAtom)
  const resetComment = useResetAtom(commentBySegmentDisplayTypeAtom)
  const resetSavedComment = useResetAtom(savedCommentBySegmentDisplayTypeAtom)
  const resetColumnsDiffs = useResetAtom(columnsDiffsAtom)

  const resetIsTabulationReady = useResetAtom(isTabulationReadyAtom)
  const resetIsPendingTabulation = useResetAtom(isPendingTabulationAtom)
  const resetTabulationData = useResetAtom(tabulationDataAtom)
  const resetHighlightedCell = useResetAtom(highlightedCellAtom)

  useUnmount(() => {
    resetColumnCustomerAttributeIds()
    resetBrandIds()
    resetQuestionIds()
    resetCustomerAttributeIds()
    resetDataDisplayType()
    resetSortValue()
    resetHiddenRowIds()
    resetComment()
    resetSavedComment()
    resetColumnsDiffs()
    resetSegmentDisplayType()
    resetIsTabulationReady()
    resetIsPendingTabulation()
    resetTabulationData()
    resetHighlightedCell()
  })
}
